import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RestService } from '../../master-services/Rest/rest.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { UploadService } from '../../master-services/services/upload.service';
import { UUID } from 'angular2-uuid';
import { ICustomerType } from '../../master-models/customer-type.model';
import { ICustomerContact } from '../../master-models/customer-contact.model';
import { ModalBasicComponent } from '../../shared/modal-basic/modal-basic.component';

interface regionalSelectInterface {// item para mostrar selccionados
  id?: number;
  code?: string,
  description?: string;
  cheked?: boolean;
}


@Component({
  selector: 'app-master-register-third',
  templateUrl: './master-register-third.component.html',
  styleUrls: ['./master-register-third.component.scss',
    '../../../assets/icon/icofont/css/icofont.scss']
})

export class MasterRegisterThirdComponent implements OnInit {
  // getTypeDocuments

  selectedFiles: FileList;
  dataMasters: any;
  dataOffices: any;
  typeDocuments: any;
  priceList: any;
  departments: any;
  department: any;
  cities: any;
  citiesOffice: any;
  citiesOfficeUpdate: any;
  paymentConditions: any;
  elementDelete: any;

  currentOffice: any;
  currentCustomerId: any = 0;

  currentUpdateOffice: any;
  currentUpdateCustomerId: any = 0;

  myForm: FormGroup;
  myFormUpdate: FormGroup;

  myFormCreateOffice: FormGroup;
  myFormUpdateOffice: FormGroup;

  opcionSeleccionado: any = 0;
  check = false;
  enable = false;

  submitted = false;
  submittedUpdated = false;

  submittedOffice = false;
  submittedOfficeUpdated = false;

  enabledCreated = true;
  enabledCreatedOffice = true;

  enabledCreatedOfficeUpdate = true;
  public imagePath;
  imgURL: any;
  public message: string;
  enabledUpdated = true;
  idCustomerCreated;

  showButtonUpdated = 0;
  selectedValue = 0;
  switchCreate = true;
  switchUpdate = true;

  selectedTypeDocumentId: any = 0;
  // selectedPriceListId: any = 0;
  selectedPaymentConditionId: any = 0;
  selectedDepartmentId: any = 0;
  selectedCityId: any = 0;

  selectedDepartmentOfficeId: any = 0;
  selectedCityOfficeId: any = 0;

  selectedDepartmentOfficeIdUpdate: any = 0;
  selectedCityOfficeIdUpdate: any = 0;

  selectedTypeDocumentIdUpdate: any = 0;
  // selectedPriceListIdUpdate: any = 0;
  selectedPaymentConditionIdUpdate: any = 0;
  selectedDepartmentIdUpdate: any = 0;
  selectedCityIdUpdate: any = 0;
  priceM: any = 0;

  checkAllRegional = false;
  regionals: Array<regionalSelectInterface> = [];
  customerTypes: ICustomerType[] = [];
  itemRegional: regionalSelectInterface;
  rowsRegional: any;
  typeDocument: any = 0;
  documentType: any = 0;
  
  userId: number = 0;
  profileType: number = 0;

  customerOrigins = [];

  newOrigin: string = '';
  originIdToEdit: number = 0;

  customerContacts: ICustomerContact[] = [];
  contactForm: any = { name: '', email: '', telephone: '', regional_id: 0 };
  isContactModalVisible = false;
  isEditingContact = false;
  editContactIndex = -1;

  @ViewChild('modalFormOrigin') modalFormOrigin: ModalBasicComponent;

  constructor(private restService: RestService, private router: Router, private uploadService: UploadService) {
    this.userId = Number(localStorage.getItem("userid"));
    this.profileType = Number(localStorage.getItem("profile"));

    this.getMasters(0);
    // this.getOffices();
    this.getAllCustomerOrigins();
    this.getRegionals();
    this.getAllCustomerTypes();

    console.log(this.currentCustomerId);

    const businessName = new FormControl('', Validators.required);
    const typeDocumentId = new FormControl('', Validators.required);
    const documentId = new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]+$")
    ]);
    const telephone = new FormControl('', [
      Validators.pattern("^[0-9]+$")
    ]);
    const email = new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]);
    const address = new FormControl('', Validators.required);
    const priceMargin = new FormControl(this.priceM);
    // const priceListId = new FormControl('', Validators.required);
    const paymentConditionId = new FormControl('', Validators.required);
    const departmentId = new FormControl('', Validators.required);
    const cityId = new FormControl('', Validators.required);
    const customerType = new FormControl(0, Validators.required);
    const customerOrigin = new FormControl(0, Validators.required);
    const comercialEmail = new FormControl('', [
      Validators.email,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]);

    const businessNameUpdate = new FormControl('', Validators.required);
    const typeDocumentIdUpdate = new FormControl('', Validators.required);
    const documentIdUpdate = new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]+$")
    ]);
    const telephoneUpdate = new FormControl('', [
      Validators.pattern("^[0-9]+$")
    ]);
    const emailUpdate = new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]);
    const addressUpdate = new FormControl('', Validators.required);
    const priceMarginUpdate = new FormControl('', Validators.required);
    // const priceListIdUpdate  = new FormControl('', Validators.required);
    const paymentConditionIdUpdate = new FormControl('', Validators.required);
    const departmentIdUpdate = new FormControl('', Validators.required);
    const cityIdUpdate = new FormControl('', Validators.required);


    const nameOffice = new FormControl('', Validators.required);
    const telephoneOffice = new FormControl('');
    const departmentOffice = new FormControl('', Validators.required);
    const citytOffice = new FormControl('', Validators.required);
    const addressOffice = new FormControl('', Validators.required);

    const nameOfficeUpdate = new FormControl('', Validators.required);
    const telephoneOfficeUpdate = new FormControl('');
    const departmentOfficeUpdate = new FormControl('', Validators.required);
    const citytOfficeUpdate = new FormControl('', Validators.required);
    const addressOfficeUpdate = new FormControl('', Validators.required);
    const priceMargin2 = new FormControl('');

    this.myFormCreateOffice = new FormGroup({
      nameOffice: nameOffice,
      telephoneOffice: telephoneOffice,
      departmentOffice: departmentOffice,
      citytOffice: citytOffice,
      addressOffice: addressOffice
    });

    this.myFormUpdateOffice = new FormGroup({
      nameOfficeUpdate: nameOfficeUpdate,
      telephoneOfficeUpdate: telephoneOfficeUpdate,
      departmentOfficeUpdate: departmentOfficeUpdate,
      citytOfficeUpdate: citytOfficeUpdate,
      addressOfficeUpdate: addressOfficeUpdate
    });


    this.myForm = new FormGroup({
      businessName: businessName,
      typeDocumentId: typeDocumentId,
      documentId: documentId,
      telephone: telephone,
      email: email,
      address: address,
      priceMargin: priceMargin,
      paymentConditionId: paymentConditionId,
      departmentId: departmentId,
      cityId: cityId,
      priceMargin2: priceMargin2,
      customerType: customerType,
      comercialEmail: comercialEmail,
      customerOrigin: customerOrigin
    });

    this.myFormUpdate = new FormGroup({
      businessNameUpdate: businessNameUpdate,
      typeDocumentIdUpdate: typeDocumentIdUpdate,
      documentIdUpdate: documentIdUpdate,
      telephoneUpdate: telephoneUpdate,
      emailUpdate: emailUpdate,
      addressUpdate: addressUpdate,
      priceMarginUpdate: priceMarginUpdate,
      paymentConditionIdUpdate: paymentConditionIdUpdate,
      departmentIdUpdate: departmentIdUpdate,
      cityIdUpdate: cityIdUpdate,
      customerType: customerType,
      comercialEmail: comercialEmail,
    });
  }

  validateFormat(event: KeyboardEvent) {
    const key = String.fromCharCode(event.keyCode);
    const regex = /^[0-9]$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  validatePaste(event: ClipboardEvent) {
    let pasteData = '';
    if (event.clipboardData) {
      pasteData = event.clipboardData.getData('text');
    }
    const regex = /^[0-9]+$/;
    if (!regex.test(pasteData)) {
      event.preventDefault();
    }
  }

  ccNit() {
    // documentType

    const data = this.selectedTypeDocumentId.id;

    if (data == 1) {
      this.documentType = 0
      console.log (data)
    } else {
      this.documentType = 1
      console.log (data)

    }
  }


  DocumentTipe() {
    this.DocumentTipe = this.myForm.get('documentId').value
  }



  getRegionals() {
    this.restService.getRegional().then(data => {
      const resp: any = data;
      console.log(resp);
      console.log('OEOEOEOEOEEO');
      console.log('---------------------------');
      this.rowsRegional = resp.data;

      console.log('información de regional');
      console.log(this.rowsRegional);
      console.log(this.rowsRegional.length);

      this.regionals = [];
      this.rowsRegional.forEach((item) => {
        console.log(item);
        this.itemRegional = {
          id: item.id,
          code: item.code,
          description: item.description
        }
        this.regionals.push(this.itemRegional);
      });

    }).catch(error => {
      console.log(error);
    });
  }
  
  getAllCustomerTypes() {
    this.restService.getAllCustomerTypes().then(data => {
      const resp: any = data;
      this.customerTypes = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  getAllCustomerOrigins() {
    this.restService.getAllCustomerOrigins().then(data => {
      const resp: any = data;
      this.customerOrigins = resp.data;

      console.log('/*/*/**//*/*/*/*', this.customerOrigins)
    }).catch(error => {
      console.log(error);
    });
  }

  checkUncheckAllPart(event: any) {

    this.checkAllRegional = event.target.checked;
    for (let i = 0; i < this.regionals.length; i++) {
      console.log('lo encontre' + i);
      this.regionals[i].cheked = event.target.checked;
    }
  }




  partChangeActive(event: any, item: any) {

    console.log('valor para editar');
    console.log(event);
    console.log(item);
    console.log(item.id);

    for (let i = 0; i < this.regionals.length; i++) {
      if (this.regionals[i].id == item.id) {
        console.log(item);
        console.log('lo encontre' + i);
        this.regionals[i].cheked = event.target.checked;
        console.log(this.regionals[i]);
      }
    }
  }

  getSelectedRegionalIds(): number[] {
    return this.regionals
      .filter(regional => regional.cheked)
      .map(regional => regional.id);
  }

  getSelectedRegionals(): Array<regionalSelectInterface> {
    return this.regionals.filter(regional => regional.cheked);
  }

  getRegionalDescription(regionalId: number): string {
    const regional = this.regionals.find(r => r.id === regionalId);
    return regional ? regional.description : 'Sin sucursal';
  }

  showContactModal(contact?: ICustomerContact, index?: number) {
    if (contact) {
      this.isEditingContact = true;
      this.editContactIndex = index;
      this.contactForm = {
        name: contact.name || '',
        email: contact.email || '',
        telephone: contact.telephone || '',
        regional_id: contact.regional_id || 0
      };
    } else {
      this.isEditingContact = false;
      this.editContactIndex = -1;
      this.contactForm = { name: '', email: '', telephone: '', regional_id: 0 };
    }
    this.isContactModalVisible = true;
  }

  closeContactModal() {
    this.isContactModalVisible = false;
    this.editContactIndex = -1;
    this.isEditingContact = false;
    this.contactForm = { name: '', email: '', telephone: '', regional_id: 0 };
  }

  saveContact() {
    if (!this.contactForm.name) {
      swal({
        title: 'Campos requeridos',
        text: 'El nombre del contacto es obligatorio',
        type: 'error',
        backdrop: false,
        toast: true,
        position: 'top',
        showConfirmButton: true
      });
      return;
    }

    const contactData: ICustomerContact = {
      regional_id: this.contactForm.regional_id || 0,
      name: this.contactForm.name,
      email: this.contactForm.email,
      telephone: this.contactForm.telephone
    };

    if (this.isEditingContact && this.editContactIndex > -1) {
      this.customerContacts[this.editContactIndex] = contactData;
    } else {
      this.customerContacts.push(contactData);
    }
    this.closeContactModal();
  }

  deleteContact(index: number) {
    swal({
      title: '¿Estás seguro de eliminar este contacto?',
      type: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    }).then((willDelete) => {
      if (willDelete.value) {
        this.customerContacts.splice(index, 1);
      }
    });
  }


  ngOnInit() {
  }


  updateBrand(brand) {
    console.log(brand);
    this.currentOffice = brand;
    console.log(this.currentOffice);
    if (this.currentOffice.status === '0') {
      this.enabledUpdated = true;
    } else {
      this.enabledUpdated = false;
    }

    this.myFormUpdateOffice.get('nameOfficeUpdate').setValue(this.currentOffice.branch_name);
    this.myFormUpdateOffice.get('telephoneOfficeUpdate').setValue(this.currentOffice.telephone);

    this.myFormUpdateOffice.get('addressOfficeUpdate').setValue(this.currentOffice.address);

    this.selectedDepartmentOfficeIdUpdate = 1;
    this.getCitiesOfficeUpdate(1);
    this.selectedCityOfficeIdUpdate = 3;

    document.getElementById('uploadBrand').click();
  }


  upload() {
    const file = this.selectedFiles.item(0);
    const uuid = UUID.UUID();
    console.log(uuid);
    console.log(file.name + '' + file.type);
    const extension = (file.name.substring(file.name.lastIndexOf('.'))).toLowerCase();
    console.log(extension);
    this.uploadService.uploadFile(file);
  }


  selectFile(event) {
    this.selectedFiles = event.target.files;
    console.log(this.selectedFiles);
  }

  ChangingValue() {
    this.selectedTypeDocumentIdUpdate = this.selectedTypeDocumentId.id;
    // this.selectedPriceListIdUpdate = this.selectedPriceListId.id;
    this.selectedPaymentConditionIdUpdate = this.selectedPaymentConditionId.id;
    this.selectedDepartmentIdUpdate = this.selectedDepartmentId.id;
    this.selectedCityIdUpdate = this.selectedCityId.id;

    console.log(this.selectedTypeDocumentIdUpdate);
  }


  getCitiesOffice() {
    // console.log(this.opcionSeleccionado);
    this.selectedCityOfficeId = 0;

    this.restService.getCities(Number(this.selectedDepartmentOfficeId.id)).then(data => {
      const resp: any = data;
      console.log(data);
      swal.close();
      this.citiesOffice = resp.data;
      console.log(this.cities);
    }).catch(error => {
      console.log(error);
    });
  }


  getCitiesOfficeUpdate(val: any) {
    // console.log(this.opcionSeleccionado);
    this.selectedCityOfficeIdUpdate = 0;
    console.log('oleole');

    this.restService.getCities(Number(val)).then(data => {
      const resp: any = data;
      console.log(data);
      swal.close();
      this.citiesOfficeUpdate = resp.data;
      console.log(this.cities);
    }).catch(error => {
      console.log(error);
    });
  }

  getCities(val: any) {
    // console.log(this.opcionSeleccionado);
    this.selectedCityId = 0;

    this.restService.getCities(Number(this.selectedDepartmentId.id)).then(data => {
      const resp: any = data;
      console.log(data);
      swal.close();
      this.cities = resp.data;
      console.log(this.cities);
    }).catch(error => {
      console.log(error);
    });
  }


  getCitiesUpdate(val: any) {
    // console.log(this.opcionSeleccionado);
    this.selectedCityIdUpdate = 0;

    this.restService.getCities(Number(this.selectedDepartmentIdUpdate)).then(data => {
      const resp: any = data;
      console.log(data);
      swal.close();
      this.cities = resp.data;
      console.log(this.cities);
    }).catch(error => {
      console.log(error);
    });
  }


  sendCustomer() {
    this.myForm.updateValueAndValidity();

    console.log('Ole ole ole');
    console.log(this.selectedTypeDocumentId);
    console.log(this.selectedPaymentConditionId);
    console.log(this.selectedDepartmentId);
    console.log(this.selectedCityId);
    console.log(this.myForm.get('customerType').value);
    console.log(this.myForm.get('comercialEmail').value);
    console.log(this.myForm.invalid);
    // console.log(this.selectedPriceListId);

    if (Number(this.selectedTypeDocumentId) !== 0 && Number(this.selectedPaymentConditionId) !== 0
      && Number(this.selectedDepartmentId) !== 0 && Number(this.selectedCityId) !== 0 && Number(this.myForm.get('customerType').value) !== 0
      && Number(this.myForm.get('customerOrigin').value) !== 0
    ) {
      this.submitted = true;
      if (!this.myForm.invalid) {

        if (this.getSelectedRegionalIds().length === 0) {
          swal({
            title: 'Debe seleccionar al menos una sucursal',
            text: 'Debe seleccionar al menos una sucursal',
            type: 'error'
          });
          return;
        }

        if (this.customerContacts.length === 0) {
          swal({
            title: 'Debe agregar al menos un contacto',
            text: 'Debe agregar al menos un contacto',
            type: 'error'
          });
          return;
        }

        swal({
          title: 'Validando información ...',
          allowOutsideClick: false
        });
        swal.showLoading();

        let statusTemp = 0;
        console.log(this.switchUpdate);
        if (this.enabledCreated === false) {
          statusTemp = 1;
        }

        console.log(this.selectedPaymentConditionId.id);
        console.log(this.myForm.get('customerType').value);
        console.log('antes de crear');

        const selectedRegionalIds = this.getSelectedRegionalIds();
        const contactsPayload = this.customerContacts.map(contact => ({
          regional_id: (contact.regional_id && selectedRegionalIds.indexOf(contact.regional_id) !== -1)
            ? contact.regional_id
            : null,
          name: contact.name,
          email: contact.email,
          telephone: contact.telephone
        }));

        const customerCompleteBody = {
          business_name: this.myForm.get('businessName').value.toUpperCase(),
          type_document_id: this.selectedTypeDocumentId.id,
          document_id: this.myForm.get('documentId').value,
          telephone: this.myForm.get('telephone').value,
          address: this.myForm.get('address').value,
          email: this.myForm.get('email').value,
          status: statusTemp,
          payment_condition_id: this.selectedPaymentConditionId.id,
          city_id: this.selectedCityId.id,
          department_id: this.selectedDepartmentId.id,
          customer_type_id: this.myForm.get('customerType').value,
          comercial_email: this.myForm.get('comercialEmail').value,
          origin_id: this.myForm.get('customerOrigin').value,
          regionals: selectedRegionalIds,
          contacts: contactsPayload
        };

        this.restService.createCustomerComplete(customerCompleteBody)
          .then(data => {
            console.log('si lo creo');
            const resp: any = data;
            console.log(resp);
            if (resp.success === false) {
              swal({
                title: 'Este tercero ya esta registrado',
                text: 'Este tercero no se puede registrar',
                type: 'error'
              });
            } else {
              this.idCustomerCreated = resp.data && resp.data.id ? resp.data.id : 0;
              this.currentCustomerId = this.idCustomerCreated;
              swal({
                title: 'Tercero agregado',
                type: 'success'
              });

              if (this.idCustomerCreated) {
                this.router.navigateByUrl('master/customersUpdate/' + this.idCustomerCreated);
              } else {
                this.router.navigateByUrl('master/customers');
              }
            }
          }).catch(error => {
            console.log(error);
          });
      }
    } else {
      swal({
        title: 'Debe seleccionar todos los campos obligatorios',
        text: 'Debe seleccionar todos los campos obligatorios',
        type: 'error'
      });
    }
  }

  // sendOffice() {
  //   try {
  //   console.log('Ole ole ole');
  //   if ( Number(this.selectedDepartmentOfficeId.id) !== 0 && Number(this.selectedCityOfficeId.id) !== 0) {
  //     this.submittedOffice = true;
  //     console.log('paso y no podia pasar');
  //     console.log(this.myFormCreateOffice.errors);
  //    if ( !this.myFormCreateOffice.invalid) {
  //     swal({
  //       title: 'Validando información ...',
  //       allowOutsideClick: false
  //     });
  //     swal.showLoading();

  //     let statusTemp = 0;
  //     console.log( this.switchUpdate);
  //     if ( this.enabledCreatedOffice === false) {
  //       statusTemp = 1;
  //     }
  //     this.restService.createOffice(this.currentCustomerId, this.myFormCreateOffice.get('nameOffice').value.toUpperCase())
  //     .then(data => {
  //       const resp: any = data;
  //       console.log(resp);
  //       if (resp.success === false) {
  //         swal({
  //           title: 'Esta sede ya esta registrada',
  //           text: 'Esta sede no se puede registrar',
  //           type: 'error'
  //          });
  //       } else {
  //    this.myFormCreateOffice.reset();
  //    document.getElementById( 'createBrandHide').click();
  //    this.getOffices(this.currentCustomerId);
  //    swal({
  //     title: 'Sede agregada',
  //     type: 'success'
  //    });
  //     }
  //     }).catch(error => {
  //       console.log(error);
  //     });
  //     }
  //   } else {
  //     console.log('llegod');
  //     swal({
  //       title: 'Debe seleccionar todos los campos obligatorios',
  //       text: 'Debe seleccionar todos los campos obligatorios',
  //       type: 'error'
  //      });
  //   }
  // } catch (error) {
  // console.log(error);
  // }
  // }


  messageError() {
    swal({
      title: 'Debe crear un cliente',
      text: 'Luego de crear el cliente, puedes crear sedes',
      type: 'error'
    });
  }


  // updatedOffice(oficcerow:any) {
  //   this.currentUpdateOffice=oficcerow;
  //   console.log("cosa a actualizar");
  //   console.log(this.currentUpdateOffice);
  //   try {
  //   if ( Number(this.selectedDepartmentOfficeIdUpdate) !== 0 && Number(this.selectedCityOfficeIdUpdate) !== 0) {
  //     this.submittedOfficeUpdated = true;

  //    if ( !this.myFormUpdateOffice.invalid) {
  //     swal({
  //       title: 'Validando información ...',
  //       allowOutsideClick: false
  //     });
  //     swal.showLoading();

  //     let statusTemp = 0;
  //     if ( this.switchUpdate === true) {
  //       statusTemp = 0;
  //     } else {
  //       statusTemp = 1;
  //     }

  //     this.restService.updateOffice(this.currentUpdateOffice.id,25, this.myFormUpdateOffice.get('nameOfficeUpdate').value.toUpperCase())
  //     .then(data => {
  //       const resp: any = data;
  //       console.log(resp);
  //       if (resp.success === false) {
  //         swal({
  //           title: 'Este tercero ya esta registrado',
  //           text: 'Este tercero no se puede registrar',
  //           type: 'error'
  //          });
  //       } else {
  //    swal({
  //     title: 'Tercero agregado',
  //     type: 'success'
  //    });
  //     }
  //     }).catch(error => {
  //       console.log(error);
  //     });
  //     }
  //   } else {
  //     console.log('llegod');
  //     swal({
  //       title: 'Debe seleccionar todos los campos obligatorios',
  //       text: 'Debe seleccionar todos los campos obligatorios',
  //       type: 'error'
  //      });
  //   }
  // } catch (error) {
  // console.log(error);
  // }
  // }

  // updatedOfficePro() {
  //   console.log("datos a actualizar");
  //   console.log(this.selectedDepartmentOfficeIdUpdate);
  //   console.log(this.selectedCityOfficeIdUpdate);

  //      try {
  //     if ( Number(this.selectedDepartmentOfficeIdUpdate.id) !== 0 && Number(this.selectedCityOfficeIdUpdate.id) !== 0) {
  //       this.submittedOffice = true;
  //       console.log('paso y no podia pasar');
  //      if ( !this.myFormUpdateOffice.invalid) {
  //       swal({
  //         title: 'Validando información ...',
  //         allowOutsideClick: false
  //       });
  //       swal.showLoading();
  //       let statusTemp = 0;
  //       console.log( this.switchUpdate);
  //       if ( this.switchUpdate === true) {
  //         statusTemp = 0;
  //       } else {
  //         statusTemp = 1;
  //       }
  //   console.log('llego');
  //       this.restService.updateOffice(this.currentOffice.id,this.currentCustomerId, this.myFormUpdateOffice.get('nameOfficeUpdate').value.toUpperCase())
  //       .then(data => {
  //         const resp: any = data;
  //         console.log(resp);
  //         if (resp.success === false) {
  //           swal({
  //             title: 'Esta sede ya esta registrada',
  //             text: 'Esta sede no se puede registrar',
  //             type: 'error'
  //            });
  //         } else {
  //      this.myFormCreateOffice.reset();
  //      document.getElementById( 'createBrandHide').click();
  //      this.getOffices(this.currentCustomerId);
  //      document.getElementById('updateBrandHide').click();
  //      swal({
  //       title: 'Sede Actualizado',
  //       type: 'success'
  //      });
  //       }
  //       }).catch(error => {
  //         console.log(error);
  //       });
  //       }
  //     } else {
  //       console.log('llegod');
  //       swal({
  //         title: 'Debe seleccionar todos los campos obligatorios',
  //         text: 'Debe seleccionar todos los campos obligatorios',
  //         type: 'error'
  //        });
  //     }
  //   } catch (error) {
  //   console.log(error);
  //   }
  // }

  updatedCustomer() {
    console.log(this.showButtonUpdated);
    console.log('Ole ole ole kakaakkaka');
    console.log(this.selectedTypeDocumentIdUpdate);
    console.log(this.selectedPaymentConditionIdUpdate);
    console.log(this.selectedDepartmentIdUpdate);
    console.log(this.selectedCityIdUpdate);
    // console.log(this.selectedPriceListIdUpdate);

    if (Number(this.selectedTypeDocumentIdUpdate) !== 0 && Number(this.selectedPaymentConditionIdUpdate) !== 0
      && Number(this.selectedDepartmentIdUpdate) !== 0 && Number(this.selectedCityIdUpdate) !== 0) {
      this.submittedUpdated = true;
      if (!this.myFormUpdate.invalid) {
        swal({
          title: 'Validando información ...',
          allowOutsideClick: false
        });
        swal.showLoading();

        let statusTemp = 0;
        console.log(this.switchUpdate);
        if (this.switchUpdate === false) {
          statusTemp = 1;
        }
        console.log('kakakaka');

        this.restService.updateCustomer(Number(this.idCustomerCreated), this.myFormUpdate.get('businessNameUpdate').value.toUpperCase(),
          this.selectedTypeDocumentIdUpdate, this.myFormUpdate.get('documentIdUpdate').value,
          this.myFormUpdate.get('telephoneUpdate').value, this.myFormUpdate.get('addressUpdate').value,
          statusTemp, this.myFormUpdate.get('priceMarginUpdate').value,
          this.selectedPaymentConditionIdUpdate, this.selectedCityIdUpdate, this.selectedDepartmentIdUpdate)
          .then(data => {
            const resp: any = data;
            console.log(JSON.stringify(resp));
            if (resp.success === false) {
              swal({
                title: 'Este tercero ya esta registrado',
                text: 'Este tercero no se puede registrar',
                type: 'error'
              });
            } else {

              this.getMasters(1);
              // this.getOffices();



              console.log('Cambio');
              /*swal({
               title: 'tercero agregada',
               type: 'success'
              });*/
              //   this.router.navigateByUrl('master/registerBrand');

              // document.getElementById( 'createBrandHide').click();
              // this.loadingData();
              swal({
                title: 'Tercero agregado',
                type: 'success'
              });
            }
          }).catch(error => {
            console.log(error);
          });
      }
    } else {
      swal({
        title: 'Debe seleccionar todos los campos obligatorios',
        text: 'Debe seleccionar todos los campos obligatorios',
        type: 'error'
      });
    }
  }




  onChangeCreated(check: any) {
    // this.switchUpdate = check;
    this.enabledCreated = check;
    // this.enabledUpdated = this.enabledCreated ;
  }


  onChangeCreatedOfficeUpdate(check: any) {
    this.enabledCreatedOfficeUpdate = check;
  }

  onChangeCreatedOffice(check: any) {
    this.enabledCreatedOffice = check;

  }

  onChangeUpdated(check: any) {
    this.switchUpdate = check;
    this.enabledUpdated = check;
  }
  getMasters(indice: number) {
    // console.log(this.opcionSeleccionado);
    this.restService.getMastersThird().then(data => {
      const resp: any = data;
      console.log('Info de getMaster');
      console.log('---------------------');
      console.log(resp);
      this.dataMasters = data;
      this.paymentConditions = this.dataMasters.payment_condition;
      this.typeDocuments = this.dataMasters.documents;
      this.departments = this.dataMasters.department;
      this.priceList = this.dataMasters.price_list;

      this.selectedTypeDocumentIdUpdate = this.dataMasters.documents;
      //  this.selectedPriceListIdUpdate = this.dataMasters.price_list;
      this.selectedPaymentConditionIdUpdate = this.dataMasters.payment_condition;
      this.selectedDepartmentIdUpdate = this.dataMasters.department;
      //this.selectedCityIdUpdate: any = 0;

      console.log('master');
      console.log(data);
      swal.close();

      /* if (indice === 1) {

         console.log('oleole2');
         console.log(this.selectedTypeDocumentId);
         console.log(this.selectedTypeDocumentId.id);
         this.selectedTypeDocumentIdUpdate = '3'; // String(this.selectedTypeDocumentId.id);
         this.selectedPriceListIdUpdate = this.selectedPriceListId;
         this.selectedPaymentConditionIdUpdate = this.selectedPaymentConditionId;
         this.selectedDepartmentIdUpdate = this.selectedDepartmentId;
         this.selectedCityIdUpdate = this.selectedCityIdUpdate;
       }*/
    }).catch(error => {
      console.log(error);
    });

  }

  getOffices(idCustomer: number) {
    // console.log(this.opcionSeleccionado);
    this.restService.getCustomerOffice(idCustomer).then(data => {
      console.log('que mas ps');
      const resp: any = data;
      console.log(resp);
      this.dataOffices = resp.data_branchoffices;
      //   this.dataOffices = this.dataOffices.data;
      console.log('master');
      swal.close();
      // this.cities = resp.data;
      console.log(this.dataOffices);
    }).catch(error => {
      console.log(error);
    });

  }


  deleteBrand(brand: any) {
    swal({
      title: 'Estás seguro de eliminar este elemento?',
      // text: 'Once deleted, you will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    })
      .then((willDelete) => {
        if (willDelete.value) {
          this.elementDelete = brand;
          console.log(brand);
          console.log(this.elementDelete);
          swal.showLoading();
          this.restService.deleteOffice(Number(this.elementDelete.id))
            .then(data => {
              swal.showLoading();
              const resp: any = data;
              console.log(resp);

              if (resp.success === false) {
                swal({
                  title: 'Esta marca presenta problemas',
                  text: 'Esta marca no se puede eliminar',
                  type: 'error'
                });
              } else {
                // this.router.navigateByUrl('master/registerBrand');
                swal({
                  title: 'Marca eliminada',
                  type: 'success'
                });
              }
            }).catch(error => {
              console.log(error);
            });
        } else {
          // swal('Fail');
        }
        console.log(willDelete);
      });
  }



  onChange(d: any) {
    console.log('jajaja');
    console.log(d);
  }

  preview(files) {
    if (files.length === 0) {
      return console.log('jaja');
    }


    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
  }

  goAdminCustomer() {
    this.router.navigateByUrl('master/customers');
  }

  toggleOriginForm(originId: number = 0) {
    if (this.modalFormOrigin.visible) {
      this.modalFormOrigin.hide();
      this.newOrigin = '';
      this.originIdToEdit = 0;
      return;
    }
    
    this.originIdToEdit = originId;
    if (originId) {
      const origin = this.customerOrigins.find(o => o.id === originId);
      if (origin) {
        this.newOrigin = origin.origin;
      }
    }
    this.modalFormOrigin.show();
  }
  
  createOrigin() {
      swal({
        title: 'Validando información ...',
        allowOutsideClick: false
      });
      swal.showLoading();

      if (!this.newOrigin) {
        swal({
          title: 'Por favor ingrese el nuevo origen',
          text: 'Debe ingresar una descripcion valida para el origen',
          type: 'error'
        });
        return;
      }

      const newOriginBody = { origin: this.newOrigin };

      this.restService.createCustomerOrigin(newOriginBody)
        .subscribe(
          data => {
            this.getAllCustomerOrigins();
            swal({
              title: 'Origen agregado',
              type: 'success'
            });
            this.toggleOriginForm();
          },
          error => {
            console.log(error);
            swal({
              title: 'Error al agregar el origen',
              text: 'Ocurrió un error al intentar agregar el nuevo origen',
              type: 'error'
            });
          }
        );
  }

  updateOrigin() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newOrigin) {
      swal({
        title: 'Por favor ingrese el origen',
        text: 'Debe ingresar una descripcion valida para el origen',
        type: 'error'
      });
      return;
    }

    const originBody = { origin: this.newOrigin };

    this.restService.updateCustomerOrigin(this.originIdToEdit, originBody)
      .subscribe(
        data => {
          this.getAllCustomerOrigins();
          swal({
            title: 'Origen modificado',
            type: 'success'
          });
          this.toggleOriginForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al modificar el origen',
            text: 'Ocurrió un error al intentar modificar el origen',
            type: 'error'
          });
        }
      );
  }

  get checkForm() { return this.myForm.controls; }
  get checkFormUpdate() { return this.myFormUpdate.controls; }
  get checkFormOffice() { return this.myFormCreateOffice.controls; }
  get checkFormOfficeUpdate() { return this.myFormUpdateOffice.controls; }

}



// WEBPACK FOOTER //
// ./src/app/master/master-register-third/master-register-third.component.ts